// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"wFZ_M1","separator":"LF3kGQ","listContainer":"rlaC_V"};